import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Image
} from "@chakra-ui/react";
import React from "react";
import { pxToRem } from "../../utils/editor.ts";

const FigureReviewModal: React.FC<{
  figureInfo: any,
  setShowFigure: (show: boolean) => void
}> = ({ figureInfo, setShowFigure }) => {

  const closeModal = () => {
    setShowFigure(false)
  };

  return (
      <Modal
        isOpen={true}
        onClose={closeModal}
        size={"sm"}
        closeOnOverlayClick={false}
        isCentered
      >
        <ModalOverlay bg={"rgba(0, 0, 0, 0.1)"} />
        <ModalContent
          maxW={pxToRem(426)}
          bg={"white"}
          borderRadius={pxToRem(24)}
          boxShadow="none"
          p={0}
        >
          <ModalCloseButton
            _focusVisible={{ boxShadow: "none" }}
            color={"#666"}
            top={pxToRem(12)}
            right={pxToRem(12)}
            fontSize={pxToRem(14)}
            borderRadius={"50%"}
          />
          <ModalBody p={0}>
            <Image  w={pxToRem(426)} src={figureInfo?.attrs?.src}></Image>
          </ModalBody>
        </ModalContent>
      </Modal>
  );
};

export default FigureReviewModal;
